import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { enableUserPreset } from '@stores/userPresetSlice';

const presetControl = {
  backgroundColor: 'hsl(0, 0%, 100%)',
  borderColor: 'hsl(0, 0%, 80%)',
  borderRadius: '4px',
  borderStyle: 'solid',
  borderWidth: '1px',
  boxSizing: 'border-box',
  minHeight: '38px',
  minWidth: '38px',
};
const presetContainer = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap',
  position: 'relative',
  overflow: 'hidden',
  padding: '2px 8px',
  boxSizing: 'border-box',
  minHeight: '38px',
  outline: '0 !important',
  transition: 'all 100ms',
  backgroundColor: 'hsl(0, 0%, 100%)',
  borderColor: 'hsl(0, 0%, 80%)',
  borderRadius: '4px',
  borderStyle: 'solid',
  borderWidth: '0px',
};
const presetItem = {
  display: 'flex',
  minWidth: 0,
  backgroundColor: '#38598a',
  borderRadius: '2px',
  margin: '2px',
  boxSizing: 'border-box',
};
const presetItemDisabled = {
  display: 'flex',
  minWidth: 0,
  backgroundColor: '#adb5bd',
  borderRadius: '2px',
  margin: '2px',
  boxSizing: 'border-box',
};
const presetItemContext = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  borderRadius: '2px',
  color: 'white',
  fontSize: '85%',
  padding: '3px',
  paddingLeft: '6px',
  boxSizing: 'border-box',
};
const presetItemIcons = {
  display: 'flex',
  borderRadius: '2px',
  paddingLeft: '4px',
  paddingRight: '4px',
  boxSizing: 'border-box',
  alignItems: 'center',
};

export const AwpPresetContainer = ({ items, clickPresetEdit, clickPresetDelete, ...props }) => {
  return (
    <div style={presetControl}>
      <div style={presetContainer}>
        {items && items.length > 0
          ? items.map((item, i) => {
              return (
                item && (
                  <AwpPresetItem
                    key={`awp-preset-item-key-${i}`}
                    item={item}
                    id={`awp-preset-item-id-${i}`}
                    onClickEdit={clickPresetEdit}
                    onClickDelete={clickPresetDelete}
                  />
                )
              );
            })
          : ''}
      </div>
    </div>
  );
};
export const AwpPresetItem = ({ item, ...props }) => {
  const dispatch = useDispatch();

  const enableItem = () => {
    let _item = { ...item };
    _item.IsEnabled = !item.IsEnabled;
    dispatch(enableUserPreset(_item));
  };
  return (
    <div style={item.IsEnabled ? presetItem : presetItemDisabled}>
      <div style={presetItemContext} onClick={enableItem}>
        {item.Name}
      </div>
      <div style={presetItemIcons}>
        {item && (
          <i
            className="fas fa-pencil-alt mx-1 my-1 awp-img-btn fa-inverse fa-xs"
            onClick={props.onClickEdit}
            title="Edit"
            id={item.Id}
          />
        )}
        <i
          className="fas fa-times mx-1 my-1 awp-img-btn fa-inverse fa-xs"
          onClick={props.onClickDelete}
          title="Delete"
          id={item.Id}
        />
      </div>
    </div>
  );
};
